import clsx from 'clsx';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { GenericOverlayIconProps, OverlayIcon } from './OverlayIcon';
import style from './SizeRecIcon.module.css';

export interface SizeRecIconProps {
  onClick: () => void;
}

export const SizeRecIcon = ({ size, colorScheme, disableShadows, looseWidth, onClick }: SizeRecIconProps & GenericOverlayIconProps) => {
  const { t } = useTranslation();
  const icon = (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={clsx(style.icon)}
    >
      <defs>
        <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop stopColor="#0500FF" offset="10%" />
          <stop stopColor="#FF85A9" offset="90%" />
        </linearGradient>

        <linearGradient id="shine" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop stopColor="white" offset="-40%">
            <animate attributeName="offset" values="-.30;.70" dur="0.75s" begin="0.5s" repeatCount="2" />
          </stop>
          <stop stopColor="black" offset="-30%">
            <animate attributeName="offset" values="0;1" dur="0.75s" begin="0.5s" repeatCount="2" />
          </stop>
          <stop stopColor="white" offset="0%">
            <animate attributeName="offset" values=".30;1.3" dur="0.75s" begin="0.5s" repeatCount="2" />
          </stop>
        </linearGradient>

        <mask id="shineMask">
          <rect x="0" y="0" width="100%" height="100%" fill="url(#shine)" />
        </mask>
      </defs>

      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" stroke="url(#gradient)" />
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" stroke="var(--post-like-heart-color-scheme)" mask="url(#shineMask)" />
    </svg>
  );

  const title = useMemo(() => t('LOC_GO_TO_SIZE_REC_BUTTON'), [t]);

  return (
    <OverlayIcon
      size={size}
      colorScheme={colorScheme}
      disableShadows={disableShadows}
      looseWidth={looseWidth}
      onClick={onClick}
      icon={icon}
      text={title}
    />
  );
};
